(function () {
  'use strict';
  var STYLE_ID = 'prestige-see-more-style';
  var BTN_ID = 'prestige-see-more-btn';
  var VISIBLE_COUNT = 4;
  var MOBILE_BREAKPOINT = 1025; // ← MODIFICATO: era 768, ora copre anche tablet

  var debounceTimer = null;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      'button#prestige-see-more-btn {',
      '  visibility: hidden !important;',
      '  display: block !important;',
      '  position: relative !important;',
      '  width: 100% !important;',
      '  margin: 8px 0 0 0 !important;',
      '  padding: 14px 0 !important;',
      '  background: #000000 !important;',
      '  background-color: #000000 !important;',
      '  border: none !important;',
      '  border-radius: 0 !important;',
      '  cursor: pointer !important;',
      '  font-size: 13px !important;',
      '  font-family: inherit !important;',
      '  color: #ffffff !important;',
      '  -webkit-text-fill-color: #ffffff !important;',
      '  text-align: center !important;',
      '  letter-spacing: 0.1em !important;',
      '  text-transform: uppercase !important;',
      '  opacity: 1 !important;',
      '}',
      'button#prestige-see-more-btn.ready { visibility: visible !important; }',
      '.prestige-see-more-hidden { display: none !important; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function applyInlineStyles(btn) {
    btn.style.setProperty('background', '#000000', 'important');
    btn.style.setProperty('background-color', '#000000', 'important');
    btn.style.setProperty('color', '#ffffff', 'important');
    btn.style.setProperty('-webkit-text-fill-color', '#ffffff', 'important');
    btn.style.setProperty('border', 'none', 'important');
    btn.style.setProperty('display', 'block', 'important');
    btn.style.setProperty('width', '100%', 'important');
    btn.style.setProperty('margin', '8px 0 0 0', 'important');
    btn.style.setProperty('padding', '14px 0', 'important');
    btn.style.setProperty('cursor', 'pointer', 'important');
    btn.style.setProperty('font-size', '13px', 'important');
    btn.style.setProperty('text-align', 'center', 'important');
    btn.style.setProperty('text-transform', 'uppercase', 'important');
    btn.style.setProperty('letter-spacing', '0.1em', 'important');
    btn.style.setProperty('opacity', '1', 'important');
  }

  function removeButton() {
    var btn = document.getElementById(BTN_ID);
    if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
  }

  function getAllMedia(container) {
    return Array.from(container.querySelectorAll('.product-gallery__media'));
  }

  function showAllMedia(container) {
    getAllMedia(container).forEach(function (item) {
      item.classList.remove('prestige-see-more-hidden');
    });
  }

  function hideExtra(items) {
    items.forEach(function (item, i) {
      if (i >= VISIBLE_COUNT) item.classList.add('prestige-see-more-hidden');
      else item.classList.remove('prestige-see-more-hidden');
    });
  }

  function initSeeMore(container) {
    // Non mostrare nel Quick View
    if (container.closest('quick-buy-modal, [id*="quick-buy-modal"]')) return;

    removeButton();
    showAllMedia(container);

    if (isMobile()) return;

    var items = getAllMedia(container);
    if (items.length <= VISIBLE_COUNT) return;

    hideExtra(items);

    var btn = document.createElement('button');
    btn.id = BTN_ID;
    btn.setAttribute('type', 'button');
    btn.textContent = 'See more';
    applyInlineStyles(btn);
    btn.style.setProperty('visibility', 'hidden', 'important');

    var expanded = false;

    btn.addEventListener('click', function () {
      expanded = !expanded;
      var current = getAllMedia(container);
      if (expanded) {
        current.forEach(function (i) { i.classList.remove('prestige-see-more-hidden'); });
        btn.textContent = 'See less';
        applyInlineStyles(btn);
        var fifthItem = current[VISIBLE_COUNT];
        if (fifthItem) {
          setTimeout(function () {
            var rect = fifthItem.getBoundingClientRect();
            window.scrollTo({ top: window.pageYOffset + rect.top - 60, behavior: 'smooth' });
          }, 150);
        }
      } else {
        hideExtra(current);
        btn.textContent = 'See more';
        applyInlineStyles(btn);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });

    container.parentNode.insertBefore(btn, container.nextSibling);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        btn.classList.add('ready');
        applyInlineStyles(btn);
        btn.style.setProperty('visibility', 'visible', 'important');
      });
    });
  }

  function scheduleInit(container) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      initSeeMore(container);
    }, 1200);
  }

  function setup() {
    var container = document.querySelector('.product-gallery__image-list');
    if (!container) return false;
    injectStyle();

    new MutationObserver(function (mutations) {
      var added = mutations.some(function (m) { return m.addedNodes.length > 0; });
      if (added) scheduleInit(container);
    }).observe(container, { childList: true, subtree: true });

    window.addEventListener('resize', function () { scheduleInit(container); });

    scheduleInit(container);
    return true;
  }

  function trySetup() {
    if (setup()) return;
    setTimeout(trySetup, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', trySetup);
  else trySetup();
})();